<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <div>
          <global-messages/>
          <router-view></router-view>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import GlobalMessages from "../../UIComponents/Messages";

export default {
  components: {GlobalMessages}
}
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active in <2.1.8 */

{
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/Content.vue